export const MESSAGES = [
/*{
    id: 1,
    fromDate: '2020-08-30 16:00:00 UTC',
    toDate: '2020-09-06 00:00:00 UTC',
    message: 'Scheduled storage infrastructure maintenance - up to 8 hours of downtime (Sep 5, 16:00 UTC - Sep 6, 00:00 UTC)',
    vcs: 1,
    url: 'https://bitbucket.status.atlassian.com/incidents/zph5mmhjg513',
    severity: 'info',
},*/
]; // last id = 1
